module.exports = __webpack_public_path__ + "img/avatar-1.2a0b12bb.jpg";